import styled from 'styled-components';

export const InputWrapper = styled.form<{ $isCentered?: boolean }>`
  flex: ${({ $isCentered }) => ($isCentered ? '0 1 auto' : '0 0 auto')};
  width: ${({ $isCentered }) => ($isCentered ? '100%' : 'auto')};
  max-width: ${({ $isCentered }) => ($isCentered ? '850px' : 'none')};
  border-top: ${({ $isCentered, theme }) =>
    $isCentered ? 'none' : `1px solid ${theme.colors.border}`};
  padding: ${({ $isCentered }) => ($isCentered ? '0' : '12px')};
  background: ${({ $isCentered, theme }) =>
    $isCentered ? 'transparent' : theme.colors.background.medium};
`;

export const InputInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 850px;
  margin: 0 auto;
`;

export const FileChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const FileChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 6px;
  padding: 4px 8px;
  background: ${({ theme }) => theme.colors.background.light};
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 12px;
`;

export const FileChipName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RemoveFileButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  border: none;
  border-radius: 4px;
  padding: 0;
  background: transparent;
  color: ${({ theme }) => theme.colors.secondaryText};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.primaryText};
  }
`;

export const InputRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
`;

export const InputFieldWrapper = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  align-items: flex-end;
`;

export const TextInput = styled.textarea<{ $hasAttach?: boolean; $isDragOver?: boolean }>`
  overflow-y: auto;
  overflow-wrap: break-word;
  width: 100%;
  min-height: 46px;
  max-height: 120px;
  box-sizing: border-box;
  box-shadow: ${({ theme, $isDragOver }) =>
    $isDragOver ? `0 0 0 2px ${theme.colors.teal}40` : 'none'};
  resize: none;
  outline: none;
  border: 1px solid
    ${({ theme, $isDragOver }) => ($isDragOver ? theme.colors.teal : theme.colors.border)};
  border-radius: 6px;
  padding: ${({ $hasAttach }) => ($hasAttach ? '8px 84px 8px 12px' : '8px 44px 8px 12px')};
  background: ${({ theme }) => theme.colors.background.light};
  color: ${({ theme }) => theme.colors.primaryText};
  font-weight: 400;
  font-size: 13px;
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  line-height: normal;
  word-break: break-word;
  letter-spacing: normal;
  white-space: pre-wrap;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &::placeholder {
    color: ${({ theme }) => theme.colors.secondaryText};
  }

  &:focus,
  &:focus-visible {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.teal}40;
    border-color: ${({ theme }) => theme.colors.teal};
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const AttachButton = styled.button`
  position: absolute;
  right: 54px;
  bottom: 8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 6px;
  padding: 0;
  background: transparent;
  color: ${({ theme }) => theme.colors.primaryText};
  cursor: pointer;

  svg,
  path {
    fill: currentcolor;
    stroke: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    opacity: 0.75;
  }
`;

export const StyledButton = styled.button`
  position: absolute;
  right: 8px;
  bottom: 8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 28px;
  border: none;
  border-radius: 6px;
  padding: 0;
  background: ${({ theme }) => theme.colors.teal};
  color: ${({ theme }) => theme.colors.white};
  font-size: 13px;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
